import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {},
    Label: {
      width: 153,
      marginRight: 17,
      padding: '11px 0'
    },
    formControl: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: 290,
      padding: 0,
      cursor: 'pointer'
    },
    isFullWidth: {
      width: '100%'
    },
    radioControl: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '20px',
      marginBottom: 16,
      borderRadius: 4,
      border: "solid 1px ".concat(theme.colors.neutral400),
      padding: 8,
      '&:last-child': {
        marginBottom: 0
      }
    },
    radioLabel: _objectSpread(_objectSpread({
      marginLeft: 10
    }, theme.typography.defaultText), {}, {
      color: theme.colors.neutral900,
      fontWeight: 400
    }),
    isReadOnly: {
      '& $formControl': {
        cursor: 'not-allowed',
        '&::before': {
          borderBottom: "1px solid ".concat(theme.colors.neutral400)
        },
        '&::after': {
          borderBottom: "1px solid ".concat(theme.colors.neutral400)
        }
      }
    },
    verticalLabel: {
      display: 'block',
      padding: '8px 0',
      marginLeft: '0 !important',
      '& $Label': {
        padding: '0 0 8px 0'
      }
    },
    horizontalLabel: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '8px 0'
    },
    vertical: {},
    horizontal: {
      '& $formControl': {
        flexFlow: 'row nowrap',
        width: '100%',
        '& $radioControl': {
          marginRight: 16,
          marginBottom: 16,
          width: 'auto',
          flex: 1,
          '&:last-child': {
            marginRight: 0
          }
        }
      }
    }
  };
});